import React, { ReactNode, useState, useEffect } from 'react';
import AppContent from './AppContent';
import { MBAppBar } from './MBAppBar';
import Footer from './Footer';
import Cookies from 'js-cookie';
import CookieBar from './cookies/CookieBar';
import FooterModal from './footerModal/FooterModal';
import { useScrollLockContext } from './contexts/ScrollLockContext';
import { useTranslation } from '../common/i18n/useTranslation';
import { useDocumentTitle } from '../utils/customHooks';
import { useTranslationContext } from '../common/i18n/TranslationProvider';
import { useLandingPageModeContext } from './contexts/LandingPageModeProvider';
import { LandingPageMode } from '../utils/enums';
import DataIsIncomplete from './LandingPage/DataIsIncomplete';
import { Backdrop } from '@mui/material';
import { useBackdropContext } from './contexts/BackDropProvider';
import { makeStyles } from 'tss-react/mui';
import { white } from '@mercedes-benz/mui5-theme';
import { useMatch } from 'react-router-dom';
import { UserDataProvider } from './client/userMenu/UserDataContext';
import { Routes } from '../routes/routes';
import { WbSpinner } from '@workbench/react';
interface FrameProps {
    children: ReactNode;
}

const useStyles = makeStyles()(() => ({
    backdrop: {
        color: white[50],
        zIndex: 9999,
    },
}));

export function Frame(props: FrameProps) {
    const [footerModalVisible, setFooterModalVisible] = useState<boolean>(false);
    const [footerModalTabName, setFooterModalTabName] = useState<string>('settings');
    const { lockScroll, unlockScroll } = useScrollLockContext();
    const [cookieBarVisible, setCookieBarVisible] = useState<boolean>(Cookies.get('c_disclaimer') === undefined);
    const translate = useTranslation();
    const { langState } = useTranslationContext();
    const { setDocumentTitle } = useDocumentTitle(translate('app_title'));
    const { mode } = useLandingPageModeContext();
    const { backdrop } = useBackdropContext();
    const { classes } = useStyles();
    const isAdminPage = useMatch(`/${Routes.admin}/*`);

    useEffect(() => {
        setDocumentTitle(translate('app_title'));
    }, [langState]);

    const showFooterModal = () => {
        setFooterModalVisible(true);
        lockScroll();
    };
    const hideFooterModal = () => {
        setFooterModalVisible(false);
        unlockScroll();
    };

    const hideCookieBar = () => {
        setCookieBarVisible(false);
    };

    const setInitialFooterModalTabName = (tabName: string) => {
        setFooterModalTabName(tabName);
    };

    const content = (
        <>
            {mode === LandingPageMode.UNEXPECTED_ERROR && <DataIsIncomplete />}
            <Backdrop className={classes.backdrop} open={backdrop}>
                {<WbSpinner />}
            </Backdrop>
            <MBAppBar setInitialFooterModalTab={setInitialFooterModalTabName} showFooterModal={showFooterModal} />
            <AppContent>{props.children}</AppContent>
            <Footer setInitialFooterModalTab={setInitialFooterModalTabName} showFooterModal={showFooterModal} />
            {footerModalVisible && (
                <FooterModal hideFooterModal={hideFooterModal} footerModalTabName={footerModalTabName} />
            )}
            {cookieBarVisible && <CookieBar showFooterModal={showFooterModal} hideCookieBar={hideCookieBar} />}
        </>
    );

    return isAdminPage ? content : <UserDataProvider>{content}</UserDataProvider>;
}

export default React.memo(Frame);
